import script from "./goRinSyo0066.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0066.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0066.vue?vue&type=style&index=0&id=01fb28bc&lang=scss"

const __exports__ = script;

export default __exports__